import { render, staticRenderFns } from "./BillingAddress.vue?vue&type=template&id=680a1bd4&scoped=true"
import script from "./BillingAddress.vue?vue&type=script&lang=js"
export * from "./BillingAddress.vue?vue&type=script&lang=js"
import style0 from "./BillingAddress.vue?vue&type=style&index=0&id=680a1bd4&prod&scoped=true&lang=css"
import style1 from "./BillingAddress.vue?vue&type=style&index=1&id=680a1bd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a1bd4",
  null
  
)

export default component.exports